import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor(private oauthService:OAuthService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    if (this.oauthService.hasValidAccessToken()) {
      let token = this.oauthService.getAccessToken();
      request = request.clone({
        headers: request.headers.set("Authorization", `Bearer ${token}`)
      });
    }

    return next.handle(request);
  }
}
